export const socialsData = {
    github: 'https://github.com/maradox49/',
    linkedIn: 'https://www.linkedin.com/in/oleh-kimak-35a71928a/',
    instagram: 'https://www.instagram.com/olehkimak/',
    twitter: 'https://twitter.com/olehkimak/',
    reddit: 'https://www.reddit.com/user/OlehKimak/',
    blogger: 'https://olehkimak.blogspot.com/',
    medium: 'https://medium.com/@olehkimak6213/',
    stackOverflow: 'https://stackoverflow.com/users/22856675/oleh-kimak/',
}